<!-- <template>
<div class="bar">
    <div class="wrapper"><img src="../../../public/logos/Cartago.png" alt="logo"></div>
    <p>Cartago Mail</p>
    <span class="material-icons">menu</span>
</div>
    <br>
<div class="mail">
  <h2 class="mailtext">Your new automated mail <br> <span class="absender">&lt;example@cartago.com&gt;</span></h2>
  <div>
    <span class="material-icons">keyboard_double_arrow_right</span>
    <span class="material-icons">more_vert</span>
  </div>  
</div>
<div class="container">
  <div class="iframeLayer"></div>
  <div class="templateHtml" style="z-index: 1; position: relative ">
    <iframe scrolling="no" :src="preview" class="iFrame" onload="this.height=this.contentWindow.document.body.scrollHeight;">
  </iframe> 
    <Preview/>
  </div>
</div>
</template>

<script>
import Preview from '../Preview.vue'
export default {
  components: {
    Preview
  }}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap');


.iFrame {
width: 100%;
min-height: 120vh;
padding-bottom: 0px;
margin-bottom: 0px;
}

.container{
position: relative;
width:100%;
}

.iframeLayer{
top: 0;
left:0;
z-index: 9;
position: absolute;
width: 100%;
height: 100%;
opacity: 0;
z-index: 30;
}

.mail{
margin-left: 3%;
display: flex;
justify-content: space-between;
align-items: center;
}

.mailtext{
font-size: 18px;
}

.absender{
font: 16px black;
}

ul {
width: 33%;
display: inline-block
}

.material-icons {
font-size: 40px;
margin-left: 10px;
color: black;
}

.bar{
background-color: lightgray;
margin: 10px;
margin-top: 30px;
padding-top: 0px;
padding-bottom: 0px;
padding-left: 10px;
padding-right: 10px;
border-radius: 30px;
border: solid black;
display: flex;
justify-content: space-between;
align-items: center;
font: black;
height:60px;
font-family: "Montserrat", sans-serif;
font-optical-sizing: auto;
font-style: normal;
font-size: 30px;

}

img{
width: 32px;
height: 32px;
}

.wrapper{
  margin-left: 10px;
  margin-top: 5px;
}

</style> -->
<template>
  <div :class=" {invert: colorMode == 'dark'}">
  <div class="bar">
    <div class="wrapper"><img src="../../../public/logos/Cartago.png" alt="logo"></div>
    <p>Cartago Mail</p>
    <span class="material-icons">menu</span>
  </div>
  <br>
  <div class="mail" :class=" {invert: colorMode == 'dark'}">
    <h2 class="mailtext">Your new automated mail <br> <span class="absender">&lt;example@cartago.com&gt;</span></h2>
    <div>
      <span class="material-icons">keyboard_double_arrow_right</span>
      <span class="material-icons">more_vert</span>
    </div>  
  </div>
  <div class="container">
    <div class="iframeLayer"></div>
    <div class="templateHtml" style="z-index: 1; position: relative">
      <iframe 
        class="iFrame" 
        :srcdoc="iframeContent" 
        frameborder="0"
        scrolling="no"
        @load="adjustIframeHeight"
        style="user-select: none;"
      ></iframe>
    </div>
  </div>
</div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { convertJsonToHtml } from '@/utils/convertJsonToHtml';
import { generateSrcDoc} from '@/utils/generateSrcDoc';

export default {
  computed: {
    ...mapGetters(['getEmailData']),
    ...mapState(['colorMode']),
    iframeContent() {
      //return convertJsonToHtml(this.getEmailData);
      const htmlContent = convertJsonToHtml(this.getEmailData, true)
      return generateSrcDoc (htmlContent, this.colorMode) 
    }
  },
  methods: {
    adjustIframeHeight(event) {
      const iframe = event.target;
      iframe.style.height = iframe.contentWindow.document.body.scrollHeight + 'px';
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap');

.iFrame {
  width: 100%;
  min-height: 120vh;
  padding-bottom: 0px;
  margin-bottom: 0px;
}

.container {
  position: relative;
  width: 100%;
}

.iframeLayer {
  top: 0;
  left: 0;
  z-index: 9;
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0;
  z-index: 30;
}

.mail {
  margin-left: 3%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.mailtext {
  font-size: 18px;
}

.absender {
  font: 16px black;
}

ul {
  width: 33%;
  display: inline-block;
}

.material-icons {
  font-size: 40px;
  margin-left: 10px;
  color: black;
}

.bar {
  background-color: lightgray;
  margin: 10px;
  margin-top: 30px;
  padding-top: 0px;
  padding-bottom: 0px;
  padding-left: 10px;
  padding-right: 10px;
  border-radius: 30px;
  border: solid black;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font: black;
  height: 60px;
  font-family: "Montserrat", sans-serif;
  font-optical-sizing: auto;
  font-style: normal;
  font-size: 30px;
}

img {
  width: 32px;
  height: 32px;
}

.wrapper {
  margin-left: 10px;
  margin-top: 5px;
}

.invert {
  background: rgb(43, 43, 43);
  color: white;
}

.invert img{
  -webkit-filter: drop-shadow(1px 1px 0 white)
                  drop-shadow(-1px -1px 0 white);
  filter: drop-shadow(1px 1px 0 white) 
          drop-shadow(-1px -1px 0 white);
}

.invert .material-icons {
  color: white;
}
</style>